<app-page-title 
    title="Modificar contraseña"
    note="Por seguridad, la nueva contraseña debe contener al menos una mayúscula, una minúscula y un número."
></app-page-title>

<app-change-password-form (onSubmit)="changePassword($event)"></app-change-password-form>

<div class="button-container">
    <fs-ui-button class="intercom-button-add" routerLink="/profile-settings" [type]="'tertiary'"  [label]="'Regresar'"></fs-ui-button>
</div>